import React, { useState } from 'react';
import axios from 'axios';


function Register() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [banner, setBanner] = useState({ show: false, message: '', type: '' });

  const handleRegister = async (e) => {
    e.preventDefault(); // Prevent default form submission

    if (password !== confirmPassword) {
      setBanner({ show: true, message: "Passwords do not match.", type: "error" });
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/register`, // updated to use env variable
        { username, email, password }
      );
      setBanner({ show: true, message: response.data.message, type: "success" });
      setUsername(''); // Clear form fields on success
      setEmail('');
      setPassword('');
      setConfirmPassword('');
    } catch (error) {
      setBanner({
        show: true,
        message: error.response?.data?.error || 'Error registering user',
        type: "error"
      });
    }
  };

  const closeBanner = () => setBanner({ ...banner, show: false });

  return (
    <div className='login-container'>
      {banner.show && (
        <div
          style={{
            background: banner.type === "success" ? "#4caf50" : "#f44336",
            color: "#fff",
            padding: "1em",
            borderRadius: "5px",
            marginBottom: "1em",
            position: "relative",
            textAlign: "center"
          }}
        >
          {banner.message}
          <button
            onClick={closeBanner}
            style={{
              position: "absolute",
              right: 10,
              top: 10,
              background: "transparent",
              border: "none",
              color: "#fff",
              fontSize: "1.2em",
              cursor: "pointer"
            }}
            aria-label="Close"
          >
            ×
          </button>
        </div>
      )}
      <h2>Register</h2>
      <form className="registration-form login-form" onSubmit={handleRegister}>
        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div className="form-group">
          <label htmlFor="username">Username:</label>
          <input type="text" id="username" value={username} onChange={(e) => setUsername(e.target.value)} />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password:</label>
          <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        <div className="form-group">
          <label htmlFor="confirmPassword">Confirm Password:</label>
          <input type="password" id="confirmPassword" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
        </div>
        <button className="submit-button" type="submit">Register</button>
      </form>
      <div className="message-container">
        <p className="message">Already have an account? <a href="./login">Login here</a></p>
        <hr></hr>
      </div>
    </div>
  );
}

export default Register;
